import Router from "./Component/router/index";
import { ToastContainer } from "react-toastify";
import toast, { Toaster } from "react-hot-toast";
import "react-toastify/dist/ReactToastify.css";
import "leaflet/dist/leaflet.css";

function App() {
  return (
    <div>
      <Router />
      <ToastContainer
        position="top-center"
        autoClose={1200}
        hideProgressBar={false}
        closeOnClick
        pauseOnHover
        draggable
        theme="light"
      />
      <Toaster
        toastOptions={{
          duration: 3000,
        }}
      />
    </div>
  );
}

export default App;
